export default {
    // host: "http://localhost/margret/",
    host: "https://margaretschool.com/api/",
}